<template>
  <header class="fixed-header" style="background-color: #F7FFF4 !important;">
    <div class="container">
      <div class="header-section d-flex justify-content-between">
        <div class="header-logo d-flex align-items-center">
          <router-link to="/applicant">
            <img
              src="@/assets/images/bloom_logo.svg"
              alt="logo"
              class="img-fluid"
            />
          </router-link>
          <div class="header-list d-flex align-items-center ms-3">
            <div class="company-section" v-if="user && user.company">
              <span class="font-bold font-15"> {{ user.company.companyName }} </span><br/>
              <span>ログインユーザー: {{ user.name }} </span>
            </div>
          </div>
        </div>
        <div class="header-list d-flex justify-content-end" style="padding: 15px 0px 0px 0px; flex: 1;">
          <ul class="d-flex header-ul">
            <li v-show="isCreateReviewUser">
              <router-link
                to="/applicant"
                id="applicants"
                exact
                class="d-flex align-items-center"
              >
                <!-- <i class="fa fa-users" aria-hidden="true"></i> -->
                登録者一覧
              </router-link>
            </li>
            <li class="contact-menu-item">
              <router-link
                to="/under-review"
                id="under-review"
                class="contact-link"
                :class="{
                  'router-link-exact-active router-link-active active': $route.path.startsWith(
                    '/under-review'
                  ),
                }"
              >
                <span
                  v-if="underReviewTotal > 0"
                  id="underReviewCount"
                  class="font-weight-bold d-inline-flex justify-content-center align-items-center unreadCount"
                  >{{ underReviewTotal }}</span>
                確認中
              </router-link>
            </li>
            <!-- <li v-show="isCreateReviewUser">
              <router-link
                to="/job-description-list"
                id="job-description-list"
                class="d-flex align-items-center"
              >
               求人一覧
              </router-link>
            </li> -->
            <li v-show="isCreateReviewUser">
              <router-link
                to="/scout-applicant"
                id="scout-applicant"
                class="d-flex align-items-center"
              >
                スカウト希望
              </router-link>
            </li>

            <!-- <li v-show="hasJDAuthority">
              <router-link to="/job-description-list/user-filter" id="matching" class="d-flex align-items-end" @click.native="handleJDListClick">
                JD一覧
              </router-link>
            </li> -->
            <!-- <li v-show="isAdmin || isCreateReviewUser">
              <router-link to="/dashboard" id="dashboard" class="d-flex align-items-end">

                プロセス実績
              </router-link>
            </li> -->
            <li v-show="isCreateReviewUser" class="contact-menu-item">
              <router-link
                to="/contact-list/received-list"
                id="contacts"
                class="contact-link"
                :class="{
                  'router-link-exact-active router-link-active active': $route.path.startsWith(
                    '/contact-list'
                  ),
                }"
              >
                <span id="unreadCount"
                  class="font-weight-bold d-inline-flex justify-content-center align-items-center unreadCount"
                  >{{ contactCount || 0 }}</span>
                送受信メッセージ
              </router-link>
            </li>
            <li>
              <router-link
                :to="settingsLink"
                id="settings"
                class="d-flex align-items-center"
                :class="{
                  'router-link-exact-active router-link-active active': $route.path.startsWith(
                    '/setting'
                  ),
                }"
              >
                <!-- <i class="fa fa-cog" aria-hidden="true"></i> -->
                設定
              </router-link>
            </li>

            <li>
              <router-link to="/logout" id="logout" class="logout-link">
                <img src='@/assets/images/Logout.png' alt="logout" class="img-fluid logout-icon" />
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="position-absolute custom-alert">
      <Notification
        v-for="(msg, idx) in getAllFlashMessages"
        :message="msg"
        :idx="idx"
        :key="idx"
      />
    </div> -->
  </header>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import mutations from '@/config/mutations';
import Notification from '../utils/Notification';

export default {
  name: 'Header',
  components: { Notification },
  computed: {
    ...mapGetters({
      isAdmin: 'currentUserIsAdmin',
      isCreateReviewUser: 'isCreateReviewUser',
      user: 'getCurrentUser',
      getContactCount: 'getRepliedContactCount',
      companyContactAuthority: 'getCompanyContactAuthority',
      jdMatchingAuthority: 'getJdMatchingAuthority',
      userContactAuthority: 'getUserContactAuthority',
      reviewLists: 'getReviewLists',
      assignedReviewLists: 'getAssignedReviewLists',
      hasAssignedApplicants: 'getHasAssignedApplicants',
      underReviewSummary: 'getUnderReviewSummary',
      reloadApplicants: 'getReloadApplicants',
    }),
    ...mapGetters(['getAllFlashMessages']),
    globalUser() {
      return true;
    },
    contactCount() {
      return this.getContactCount;
    },
    underReviewTotal() {
      return (this.underReviewSummary && this.underReviewSummary.total) || 0;
    },
    hasIndividualContactAuthority() {
      return this.isCreateReviewUser && this.companyContactAuthority;
    },
    hasJDAuthority() {
      return this.jdMatchingAuthority && this.isCreateReviewUser;
    },

    settingsLink() {
      const links = [
        {
          path: '/setting/users',
          label: '企業内ユーザー追加・削除',
          show: this.isAdmin,
        },
        {
          path: '/setting/review-list',
          label: 'リスト設定',
          show: this.isCreateReviewUser,
        },
        // { path: '/setting/occupation-list', label: '募集中の職種分類設定', show: this.isCreateReviewUser },
        {
          path: '/setting/password',
          label: 'パスワード変更',
          show: this.globalUser,
        },
      ];
      let filteredLinks = links.filter((link) => link.show);
      return filteredLinks[0] ? filteredLinks[0].path : '';
    },
  },
  mounted() {
    this.loadCurrentUser();
    this.loadCurrentUser().then(() => {
      if (this.isCreateReviewUser) {
        this.loadAssignedReviewLists().then(() => {
          if (this.assignedReviewLists && this.assignedReviewLists.length) {
            const firstAssigned = this.assignedReviewLists[0];
            if (firstAssigned && firstAssigned._id) {
              this.checkAssignedReviewList(firstAssigned._id);
            }
          }
        }).catch(() => {});
      }
    });
    this.loadCurrentUserDefaultSearch();
    this.loadReceivedContactsCount();
    this.loadReviewLists();
    this.loadUnderReviewSummary();
  },

  methods: {
    ...mapActions({
      loadCurrentUser: 'loadCurrentUser',
      loadCurrentUserDefaultSearch: 'loadCurrentUserDefaultSearch',
      loadReceivedContactsCount: 'loadReceivedContactsCount',
      loadAllJDs: 'jd/getAllJDs',
      loadReviewLists: 'loadReviewLists',
      loadAssignedReviewLists: 'loadAssignedReviewLists',
      checkAssignedReviewList: 'checkAssignedReviewList',
      loadUnderReviewSummary: 'loadUnderReviewSummary',
    }),
    ...mapMutations({
      clearAll: 'jd/clearAll',
      clearAllJds: 'jd/clearAllJDs',
    }),
    handleJDListClick(event) {
      if (this.$route.path === '/job-description-list/user-filter') {
        event.preventDefault();
        this.clearAll();
        this.clearAllJDs();
        this.loadAllJDs();
      }
    },
    logout() {
      this.$router.push('/logout');
    },
  },
  watch: {
    assignedReviewLists: {
      handler(newLists, oldLists) {
        // Only check when lists change and we have a first assigned list
        // Avoid checking on initial mount (handled in mounted hook)
        if (oldLists === undefined) return;
        
        if (newLists && newLists.length && this.isAdmin) {
          const firstAssigned = newLists[0];
          if (firstAssigned && firstAssigned._id) {
            this.checkAssignedReviewList(firstAssigned._id);
          }
        }
      },
      immediate: false,
    },
    reloadApplicants(isReloading) {
      // Status changes (individual or bulk) toggle this flag app-wide — piggyback on it
      // to keep the badge count live instead of only refreshing it on a full page load.
      if (isReloading) this.loadUnderReviewSummary();
    },
  },
};
</script>
<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
}

.company-section {
  max-width: 400px;
}
.unreadCount {
  margin-bottom: 0;
  color: #fff;
  font-size: 10px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #006C6B;
  flex-shrink: 0;
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 10;
}

.font-15 {
  font-size: 15px;
}

.custom-alert {
  position: absolute;
  left: 0;
  right: 0;
  width: 30%;
  margin-left: auto;
  margin-right: auto;
  z-index: 900;  /* Lower than header z-index to prevent overlap */
}

p {
  color: #3c3c3c;
  font-size: 14px;
}

.header-list .router-link-active {
  color: #006c6b !important;
  font-weight: bold;
  border-bottom: 5px solid #006c6b !important;
  padding-bottom: 0px;
  background-color: #e8e8e8;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 4px 4px 0 0;
  height: 60px;
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.header-ul {
  gap: 15px;
}

.header-ul a {
  color: #3c3c3c;
  text-decoration: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.header-ul a:hover {
  color: #006c6b;
}

.header-ul li.contact-menu-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
}



.header-ul a.contact-link {
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 0 25px !important;
  white-space: nowrap;
  color: #3c3c3c;
  text-decoration: none;
  min-width: fit-content;
  position: relative;
  top: 0;
  transition: all 0.1s ease;
  height: 100%;
}

.header-ul a.contact-link:hover {
  color: #006c6b !important;
}

.header-ul a.contact-link.router-link-active {
  color: #006c6b !important;
  font-weight: bold;
  border-bottom: 5px solid #006c6b !important;
  padding-bottom: 0px !important;
  padding-left: 25px !important;
  padding-right: 25px !important;
  padding-top: 10px !important;
  top: 0px;
  background-color: #e8e8e8;
  border-radius: 4px 4px 0 0;
  height: 60px;
  display: flex;
  align-items: center;
}

.logout-link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  height: 60px;
  transition: all 0.2s ease;
}

.logout-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.logout-icon {
  max-height: 28px;
  width: auto;
}


/* Responsive styles for smaller screens and zoom levels */
@media (max-width: 1600px) {
  .header-ul {
    gap: 15px;
  }
}

@media (max-width: 1440px) {
  .header-ul {
    gap: 15px;
  }
}

@media (max-width: 1366px) {
  .header-ul {
    gap: 15px;
  }
  
  .header-ul a {
    font-size: 13px;
  }
}

@media (max-width: 1280px) {
  .header-ul {
    gap: 12px;
  }
  
  .header-ul a {
    font-size: 13px;
  }
  
  .company-section {
    max-width: 280px;
  }
}

@media (max-width: 1200px) {
  .header-ul {
    gap: 15px;
  }
  
  .header-ul a {
    font-size: 12px;
  }
  
  .company-section {
    max-width: 250px;
  }
  
  .company-section span {
    font-size: 12px;
  }
  
  .company-section .font-15 {
    font-size: 13px;
  }
}

@media (max-width: 992px) {
  .header-ul {
    gap: 12px;
  }
  
  .header-ul a {
    font-size: 11px;
  }
  
  .company-section {
    max-width: 200px;
  }
  
  .company-section span {
    font-size: 11px;
  }
  
  .company-section .font-15 {
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .header-ul {
    gap: 8px;
  }
  
  .header-ul a {
    font-size: 10px;
  }
  
  .company-section {
    max-width: 150px;
  }
  
  .header-logo img {
    max-width: 80px;
  }
  
  .header-section {
    padding: 5px 0;
  }
}
</style>
